/** 首页 */
export default{
    frontPage: "หน้าแรก", // 首页
    day: "วัน", // 日
    month: "ดวงจันทร์", // 月
    week: "สัปดาห์", // 周
    year: "ปี", // 年
    PCS: "ชิ้น", // 设备台数
    cumulativeTrafficOverview: "ภาพรวมการจราจรสะสม", // 累计客流概览
        cumulativePassengerFlowToday:"ยอดผู้โดยสารสะสมวันนี้", // 今日累计客流 Cumulative passenger flow today
        comparedToYesterday: "เมื่อเทียบกับเมื่อวาน", // 较昨日 compared to yesterday
        cumulativePassengerFlowThisMonth: "ยอดผู้โดยสารสะสมในเดือนนี้", // 本月累计客流 Cumulative passenger flow this month
        comparedWithLastMonth: "เมื่อเทียบกับเดือนที่แล้ว", // 较上月 Compared with last month
        cumulativePassengerFlowThisYear: "ยอดผู้โดยสารสะสมในปีนี้", // 本年累计客流 Cumulative passenger flow this year
        comparedToLastYear: "เมื่อเทียบกับปีที่แล้ว", // 较去年 compared to last year
        cumulativePassengerFlowYesterday: "ยอดผู้โดยสารสะสมเมื่อวาน", // 昨日累计客流 Cumulative passenger flow yesterday
        cumulativePassengerFlowLastMonth: "ยอดผู้โดยสารสะสมเดือนที่แล้ว", // 上月累计客流 Cumulative passenger flow last month
        cumulativePassengerFlowLastYear: "ยอดผู้โดยสารสะสมปีที่แล้ว", // 去年累计客流 Cumulative passenger flow last year
        overviewOfDeviceInformation: "ภาพรวมข้อมูลอุปกรณ์", // 设备信息概览 Overview of device information
            onlineDevice: "อุปกรณ์ออนไลน์", // 在线设备 online device
            offlineDevice: "อุปกรณ์ออฟไลน์", // 离线设备 offline device
            total: "ทั้งหมด", // 总数 total
    announcement: "ประกาศ", // announcement
        viewAll: "ดูทั้งหมด", //查看全部 view all
    entityPassengerFlow: "กระแสผู้โดยสารนิติบุคคล (สอบถามเฉพาะ 10 อันดับแรก)", // Entity passenger flow (only query the top 10) 实体客流(只查询排行前10)
    listOfPhysicalPassengerFlow: "รายชื่อการไหลของผู้โดยสารทางกายภาพ", // 实体客流一览 List of physical passenger flow
    toDayPassenger: "ถึงผู้โดยสารรายวัน", // 当日客流
    toMonthPassenger: "ถึงผู้โดยสารเดือน", // 当月客流
    toYearPassenger: "ถึงผู้โดยสารปี", // 当年客流
    totalPassenger: "จำนวนผู้โดยสารทั้งหมด", // 累计客流
    passengerFlowPerson: "การไหลของผู้โดยสาร (คน)", // 客流(人)
    time: "เวลา", // 时间
}